import { Alert, Button } from "@mui/material";
import { RejectionRoutingDialog } from "components/Submission/RejectionRoutingDialog";
import { useCurrentUser } from "hooks/useCurrentUser";
import { useWasteStepper } from "hooks/useWasteStepper";
import { useState } from "react";

/**
 * Every step is read-only until rejection routing resolves the rejection, so the
 * reason shows on all of them. Only staff can route, so only they get the action.
 */
export function RejectionNotice({ submissionId }: { submissionId: string }) {
  const { isStaff } = useCurrentUser();
  const { isRejected } = useWasteStepper();
  const [routingOpen, setRoutingOpen] = useState(false);

  if (!isRejected) return null;

  return (
    <>
      <Alert
        severity="warning"
        sx={{ mb: 2 }}
        action={
          isStaff ? (
            <Button color="inherit" size="small" onClick={() => setRoutingOpen(true)}>
              Resolve
            </Button>
          ) : undefined
        }
      >
        This submission has been <strong>rejected</strong> by a reviewer.{" "}
        {isStaff
          ? "Use rejection routing to determine next steps."
          : "Encamp staff will route it before it can be edited again."}
      </Alert>
      {routingOpen && (
        <RejectionRoutingDialog
          open={routingOpen}
          onClose={() => setRoutingOpen(false)}
          submissionId={submissionId}
          additionalRefetchQueries={["GetSubmissionStepper"]}
        />
      )}
    </>
  );
}
